import { type FireAnalyticsEvent } from '../../types';

export const onRecommendationsCacheAccess = ({
	searchSessionId,
	hit,
}: {
	searchSessionId?: string;
	hit: boolean;
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: 'searchPage',
	action: '3pRecommendationStatus',
	attributes: {
		additionalAttributes: {
			status: hit ? 'CACHE_HIT' : 'CACHE_MISS',
			searchSessionId,
		},
	},
});
